import {useEffect} from "react";

// useEffect lets you run side effects in Functional Components; 
// [] on the useEffect meansrun this effect once, when the component mounts 
// (like componentDidMount in class components).

export const ScriptComp = () => {
    useEffect(() => {
        // Run code after the component has rendered. 
        //Variable for closing menu when the nav link is clicked
        const navLinks = document.querySelectorAll(".nav-menu .nav-link");
        const menuOpenButton = document.querySelector("#menu-open-button");
        const menuClosedButton = document.querySelector("#menu-close-button");

        const handleClick = () => {
            document.body.classList.toggle("show-mobile-menu");
        };

        const handleClosedClick = () => {
            document.body.classList.remove("show-mobile-menu"); 
        };

        if(menuOpenButton){
            menuOpenButton.addEventListener("click", handleClick);
        }

        if(menuClosedButton){
            menuClosedButton.addEventListener("click", handleClosedClick);
        }

        //Testing: handleClosedClick 
        navLinks.forEach(link => {

            link.addEventListener("click", handleClosedClick);
            
        });

        //Cleanup of the listener on unamount;
        return () => {
            if(menuOpenButton){
                menuOpenButton.removeEventListener("click", handleClick);
            }

            if(menuClosedButton){
                menuClosedButton.removeEventListener("click", handleClosedClick);
            }

            //Cleanup to prevent any memory leaks; 
            navLinks.forEach(link => {
                link.removeEventListener("click", handleClosedClick);
            })
            
        };

    },[]);

    // No visual output
    return null;
   
}


// const menuOpenButton = document.querySelector ("#menu-open-button");
// menuOpenButton.addEventListener("click", () => {
    
//     //Toggle mobile menu Visibility;
//     document.body.classList.toggle("show-mobile-menu");
// })